import { routes_names } from "@/router/constants";

export const sidebar = [
  {
    text: 'Dashboard',
    icon: 'house-fill',
    to: {
      name: routes_names.main,
    },
  },
  {
    text: 'Prompts',
    icon: 'house-fill',
    to: {
      name: routes_names.prompts,
    },
  },
  {
    text: 'Plans',
    icon: 'house-fill',
    to: {
      name: routes_names.plans,
    },
  },
]